module.exports = __webpack_public_path__ + "img/ravellonotizie.224de0c9.png";